import { buildProps } from "@xplus/utils/props";
import type { ExtractPropTypes } from "vue";

export const rateProps = buildProps({
  colors: {
    type: Array,
    default: () => ["#FAD20C", "#FAD20C", "#FAD20C"],
  },
  voidColor: {
    type: String,
    default: "#D8DADD",
  },
} as const);

export type RateProps = ExtractPropTypes<typeof rateProps>;
